import React, { useState } from "react";
import { useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { getEmpresaById } from "../../services/api_cadastros_empresas";
import { getEmpresas } from "../../services/api_base";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const FiltroModal = ({
  filtro,
  handleClose,
  setFiltro,
  handleGenerate,
  handleCloseModal,
}) => {
  const [empresa, setEmpresa] = useState("");
  const [nomeEmpresa, setNomeEmpresa] = useState("");
  const [unidade, setUnidade] = useState("");
  const [nomeUnidade, setNomeUnidade] = useState("");
  const [dataInicial, setDataInicial] = useState("");
  const [dataFinal, setDataFinal] = useState("");
  const [unidadeListagem, setUnidadesListagem] = useState([]);
  const [empresasListagem, setEmpresasListagem] = useState([]);
  const [showMessage, setShowMessage] = useState(true);
  const [isLoading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEmpresas = () => {
      Swal.fire({
        title: "Carregando dados...",
        didOpen: async () => {
          Swal.showLoading();
          try {
            const response = await getEmpresas("opa");
            //console.log("informações empresas", response);

            if (response && response.status === 200) {
              const empresasAtivas = response.data.empresas.filter(
                (empresa) => empresa.deleted_at == null
              );
              setEmpresasListagem(empresasAtivas);
              setLoading(false)
              setShowMessage(true);
              Swal.close();
            } else {
              return Swal.fire({
                icon: "error",
                title: "Erro interno",
                text: "Não foi possível carregar os dados necessários para gerar relatórios. Tente novamente mais tarde.",
                confirmButtonText: "Tentar novamente",
                preConfirm: fetchEmpresas(),
              });
            }
            //console.log(response);
          } catch (error) {
            console.error("Erro ao obter empresas:", error);
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      });
    };

    fetchEmpresas();
  }, []);

  const handleUnidadesEmpresa = async (idEmpresa) => {
    if(!idEmpresa) {
      setUnidadesListagem([])
      setShowMessage(false)
      return;
    }
    Swal.fire({
      title: "Carregando unidades da empresa",
      didOpen: async () => {
        Swal.showLoading();
        try {
          const response = await getEmpresaById(idEmpresa);
          if (response.status === 200) {
            const unidadesAtivas = response.data.empresa.unidades.filter(
              (unidade) => unidade.deleted_at == null
            );
            setUnidadesListagem(unidadesAtivas);
            Swal.close();
          }
        } catch (error) {
          console.error(error);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
  };

  // Função para lidar com a submissão do formulário
  const handleGenerateRelatorio = () => {
    try {
      handleGenerate({
        empresa,
        unidade,
        nomeEmpresa,
        nomeUnidade,
        //dataInicial,
        //dataFinal
      });
      handleClose();
    } catch (error) {
      console.error("Erro ao gerar relatório:", error);
    }
  };

  const handleGoHome = () => {
    navigate("/home");
  };

  const handleClearClick = () => {
    setEmpresa("");
    setUnidade("");
    setNomeEmpresa("");       
    setNomeUnidade(""); 
  };

  return (
    <Modal 
      show={true} 
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      aria-hidden={false}
    >
    
      <Modal.Header closeButton onHide={handleGoHome}>
        <Modal.Title>Filtrar Relatório</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="formUnidade">
            <Form.Label>Empresa</Form.Label>
            <Form.Control
              as="select"
              value={empresa}
              onChange={(e) => {
                setEmpresa(e.target.value);
                handleUnidadesEmpresa(e.target.value);
                setNomeEmpresa(
                  e.target.options[e.target.selectedIndex].getAttribute(
                    "data-nome"
                  )
                );

                //console.log(nomeEmpresa);
              }}
              required
            >
              <option value="">Selecione</option>
              {empresasListagem &&
                empresasListagem.map((empresa) => (
                  <option
                    key={empresa.id}
                    value={empresa.id}
                    data-nome={empresa.nome}
                  >
                    {empresa.nome}
                  </option>
                ))}
            </Form.Control>
            {showMessage && !empresa && (
            <small className="form-text text-danger">
              Escolha uma empresa
            </small>
          )}
          </Form.Group>
          <Form.Group controlId="formUnidade">
            <Form.Label>Unidade</Form.Label>
            <Form.Control
              as="select"
              value={unidade}
              disabled={!empresa ? true : false}
              onChange={(e) => {
                setUnidade(e.target.value);
                setNomeUnidade(
                  e.target.options[e.target.selectedIndex].getAttribute(
                    "data-nome"
                  )
                );
                //console.log(nomeUnidade);
              }}
            >
              <option value="">Selecione</option>
              {unidadeListagem &&
                unidadeListagem.map((unidade, index) => (
                  <option
                    key={index}
                    value={unidade.id}
                    data-nome={unidade.nome}
                  >
                    {unidade.nome}
                  </option>
                ))}
            </Form.Control>
          </Form.Group>
          {/*<Form.Group controlId="formDataInicio">
                        <Form.Label>Data de Início</Form.Label>
                        <Form.Control
                            type="date"
                            value={dataInicial}
                            onChange={(e) => setDataInicial(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group controlId="formDataFim">
                        <Form.Label>Data de Fim</Form.Label>
                        <Form.Control
                            type="date"
                            value={dataFinal}
                            onChange={(e) => setDataFinal(e.target.value)}
                        />
                    </Form.Group>*/}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Link to={`/home`}>
          <button className="btn btn-light text-dark">
            <FontAwesomeIcon icon={faHome} size="1x" color= 'gray' />
          </button>
        </Link>
        <Button 
          variant={!empresa ? "secondary" : "primary"} 
          onClick={handleGenerateRelatorio} 
          disabled = {!empresa}>
          Gerar
        </Button>
        <Button variant="danger" onClick={handleClearClick}>
          Cancelar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FiltroModal;
